import { alpha, type Theme } from '@mui/material/styles';

export interface JsonCodeEditorColors {
  isDark: boolean;
  panelBg: string;
  border: string;
}

export function getJsonCodeEditorColors(theme: Theme): JsonCodeEditorColors {
  const isDark = theme.palette.mode === 'dark';

  return {
    isDark,
    panelBg: isDark ? theme.palette.grey[900] : theme.palette.grey[50],
    border: isDark
      ? alpha(theme.palette.common.white, 0.12)
      : alpha(theme.palette.common.black, 0.12),
  };
}
